import {
  IManagerConfig, IPsmMgrConfig,
} from './interfaces'
import { checkObjEquality } from '../utils'
import { PSM_CONFIG_PATH } from './constants'
import PsmBridge from './psm-bridge'

class PsmMgrConfig implements IManagerConfig {
  brand: string
  brandToken: string
  bootstrapVersion: string
  baseURL: string = PSM_CONFIG_PATH
  psmMgrConfig: IPsmMgrConfig | undefined
  currentPsmTelRollout: number | null = null
  versionPath: string

  constructor() {
    this.versionPath = PsmBridge.dependencies.getVersionPath()
    const brandToken = PsmBridge.psm.getBrandToken()
    this.brandToken = brandToken ? brandToken.toLowerCase() : PsmBridge.psm.getBrand().toLowerCase()
  }

  async getAndCheckPsmMgrConfigCDN(): Promise<boolean> {
    const fullURL: string = `${this.baseURL}/${this.brandToken}/${this.versionPath}/psm.json`

    try {
      const data = await fetch(fullURL, { cache: 'no-cache'})
      const dataRes = await data.json()

      const isSameConfig: boolean = checkObjEquality<IPsmMgrConfig>(this.psmMgrConfig, dataRes)

      if (!isSameConfig) {
        this.psmMgrConfig = dataRes
        return true
      } else {
        return false
      }
    } catch (error) {
      console.error('Error in getting Prism Manager Config = error message:', error.message)
      return true
    }
  }

  getThrottleFlag(): boolean {
    if (this.currentPsmTelRollout === null || this.currentPsmTelRollout !== this.psmMgrConfig?.psmRolloutPercentages?.psmTel) {
      const userThrottleTest: number = parseInt(Date.now().toString().slice(-2))
      this.currentPsmTelRollout = this.psmMgrConfig?.psmRolloutPercentages?.psmTel ?? 100
      if (this.currentPsmTelRollout >= userThrottleTest || this.currentPsmTelRollout === 100) {
        return false
      } else {
        return true
      }
    } else {
      return PsmBridge.isThrottled
    }
  }
}

export default PsmMgrConfig
